module.exports = __webpack_public_path__ + "img/grid-1.39cb7b00.svg";